import { CUSTOMER_APIS } from "@/api_framework/api_config";
import {
  ICustomerCallButtonStatusResponse,
  ICustomerCallButtonStatusResponseData,
} from "@/api_framework/api_modals/Pets";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

import { useAPIUtils } from "../../useAPIUtils";
AxiosCurlirize(axios, () => {});
export const useCustomerCallStatusAPI = () => {
  const [callButtonStatus, setCallButtonStatus] = useState<ICustomerCallButtonStatusResponseData>(null);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (userId: string, mobile: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(CUSTOMER_APIS?.CHECK_CALL_BUTTON_STATUS?.baseURL ?? "", {
          params: {
            user_id: userId,
            mobile: mobile,
          },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICustomerCallButtonStatusResponse>) => {
          if (res.data.status === true) {
            setCallButtonStatus(res.data.data);
          } else {
            setCallButtonStatus(null);
          }
        })
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);
          setCallButtonStatus(null);
        });
    } catch (e: any) {
      setCallButtonStatus(null);
      toast.error("Search API Failed: " + e.message);
    }
  }, []);
  return { execute, callButtonStatus };
};
